import React, { useState, useEffect } from "react";
import { Plane, Menu, X, ArrowUpRight } from "lucide-react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import Logo from "../../assets/Logo1.png";

const FrontHeader = () => {
  const navigate = useNavigate();

  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === "Escape") setIsMenuOpen(false);
    };
    window.addEventListener("keydown", handleEsc);
    return () => window.removeEventListener("keydown", handleEsc);
  }, []);

  return (
    <div className="sticky top-0 z-50">
      <nav className="flex items-center justify-between px-6 lg:px-12 py-5 bg-white backdrop-blur-md border-b border-slate-100 relative z-[101]">
        <div
          className="flex items-center gap-2 font-bold text-xl lg:text-2xl text-slate-primary cursor-pointer"
          onClick={() => navigate("/")}
        >
          <img src={Logo} alt="Logo" className="w-10 h-10 object-contain" />
          <span>JustForPoints</span>
        </div>
        {/* <Plane className="rotate-45 text-voyage-cyan" size={28} /> */}

        <div className="hidden md:flex gap-8 font-medium text-slate-600">
          <NavLink
            to="/how-it-works"
            className={({ isActive }) =>
              isActive
                ? "text-voyage-cyan font-semibold"
                : "hover:text-voyage-cyan transition-colors"
            }
          >
            How It Works
          </NavLink>

          <NavLink
            to="/features"
            className={({ isActive }) =>
              isActive
                ? "text-voyage-cyan font-semibold"
                : "hover:text-voyage-cyan transition-colors"
            }
          >
            Features
          </NavLink>

          <NavLink
            to="/contact"
            className={({ isActive }) =>
              isActive
                ? "text-voyage-cyan font-semibold"
                : "hover:text-voyage-cyan transition-colors"
            }
          >
            Contact
          </NavLink>

          <NavLink
            to="/about"
            className={({ isActive }) =>
              isActive
                ? "text-voyage-cyan font-semibold"
                : "hover:text-voyage-cyan transition-colors"
            }
          >
            About
          </NavLink>

          <NavLink
            to="/blog"
            className={({ isActive }) =>
              isActive
                ? "text-voyage-cyan font-semibold"
                : "hover:text-voyage-cyan transition-colors"
            }
          >
            Blog
          </NavLink>
        </div>

        <div className="flex items-center gap-4">
          <button
            type="button"
            onClick={() => navigate("/login")}
            className="hidden sm:block bg-slate-primary text-white px-4 lg:px-6 py-2 rounded-lg font-bold text-sm lg:text-base hover:bg-slate-800 transition shadow-md shadow-slate-200"
          >
            Login
          </button>

          <button
            onClick={toggleMenu}
            className="md:hidden text-slate-primary p-1 transition-colors"
            aria-label="Toggle Menu"
          >
            {isMenuOpen ? (
              <X
                size={28}
                className="text-voyage-cyan animate-in fade-in zoom-in duration-300"
              />
            ) : (
              <Menu
                size={28}
                className="animate-in fade-in zoom-in duration-300"
              />
            )}
          </button>
        </div>
      </nav>

      <div
        className={`
          absolute top-full left-0 w-full bg-space-dark border-b border-white/10 transition-all duration-300 ease-in-out md:hidden overflow-hidden z-[100]
          ${isMenuOpen ? "max-h-[450px] opacity-100 shadow-2xl" : "max-h-0 opacity-0 pointer-events-none"}
        `}
      >
        <div className="flex flex-col p-6 space-y-1">
          {[
            { name: "How It Works", to: "/how-it-works" },
            { name: "Features", to: "/features" },
            { name: "Contact", to: "/contact" },
            { name: "About", to: "/about" },
            { name: "Blog", to: "/blog" },
          ].map((item) => (
            <Link
              key={item.name}
              to={item.to}
              onClick={() => setIsMenuOpen(false)}
              className="flex items-center justify-between py-4 px-4 rounded-xl hover:bg-white/5 group transition-colors"
            >
              <span className="text-lg font-bold text-white group-hover:text-voyage-cyan transition-colors">
                {item.name}
              </span>
              <ArrowUpRight
                size={18}
                className="text-white/20 group-hover:text-voyage-cyan transition-all"
              />
            </Link>
          ))}

          <div className="pt-4 mt-2 border-t border-white/5">
            <button
              type="button"
              onClick={() => navigate("/login")}
              className="w-full bg-voyage-cyan text-space-dark py-4 rounded-xl text-xs font-black uppercase tracking-widest active:scale-[0.98] transition-all shadow-lg shadow-voyage-cyan/10"
            >
             Login
            </button>
          </div>
        </div>
      </div>

      {isMenuOpen && (
        <div
          className="fixed inset-0 bg-black/20 backdrop-blur-[2px] md:hidden z-[99]"
          onClick={() => setIsMenuOpen(false)}
        />
      )}
    </div>
  );
};

export default FrontHeader;
